import * as React from 'react';
import { ArticleHeading2, Button } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IResultMessageProps {
  isDesktop: boolean;
  resultText: string;
  image: string;
  buttonText: string;
  onClickButton: () => void;
}

export const ResultMessage: React.FC<IResultMessageProps> = ({
  isDesktop,
  resultText,
  image,
  buttonText,
  onClickButton,
}) => {
  return (
    <section className={styles['container']}>
      <img src={image} width="80" height="70" alt="" />
      <ArticleHeading2 as="h2" textAlign="center">
        {resultText}
      </ArticleHeading2>
      <Button
        size={isDesktop ? 'XS' : 'M'}
        fullWidth={!isDesktop}
        theme="fill_primary"
        onClick={onClickButton}
        data-testid="leaveContactsDialogResultConfirm"
      >
        {buttonText}
      </Button>
    </section>
  );
};
